/**
 * HTTP service for the org-admin portfolio read (PX-W7.9, TASK-17A2C062) —
 * `GET /{orgId}/admin-portfolio`, the ONE roster-free project read (project
 * memory `px-org-admin-portfolio-read-all`). `orgId` is an explicit argument,
 * not the `{orgId}` transport placeholder, mirroring the other cross-project
 * reads (`crossProjectReadService`) — a self-scoped GET whose org the caller
 * names rather than the active-org substitution.
 */

import { apiClient } from '@/services'
import type { AdminPortfolioView } from '../types'

export const adminPortfolioService = {
  /** Every enabled project of `orgId`, with its roster, current gate and client name. */
  get(orgId: string): Promise<AdminPortfolioView> {
    return apiClient.get<AdminPortfolioView>(`/${orgId}/admin-portfolio`)
  }
}
